module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.isSurvey
  }, [(_vm.loggedIn) ? _c('div', {
    staticClass: "gutter-horizontal",
    class: _vm.fullTemplate.gutter
  }, _vm._l((_vm.pages), function(page, index) {
    return _c('div', {
      key: index,
      staticClass: "slide",
      class: [_vm.slide_active(index).class, _vm.slide_in_queue(index)]
    }, [_c(page.template, {
      tag: "component",
      attrs: {
        "content": page.content,
        "title": page.title,
        "active": _vm.slide_active(index).bool
      }
    }, [_vm._v("\n        " + _vm._s(page.content) + "\n      ")])], 1)
  })) : _vm._e(), _vm._v(" "), (_vm.loggedIn) ? _c('progress-bar', {
    attrs: {
      "complete": _vm.percentComplete,
      "hidden": _vm.fullTemplate.progressHidden
    }
  }) : _vm._e(), _vm._v(" "), (_vm.loggedIn) ? _c('page-bar') : _vm._e(), _vm._v(" "), (_vm.loggedIn) ? _c('readButton') : _vm._e(), _vm._v(" "), (_vm.loggedIn) ? _c('navbar', {
    attrs: {
      "nextCondition": _vm.nextCondition
    }
  }) : _vm._e(), _vm._v(" "), (_vm.loggedIn) ? _c('notification', {
    attrs: {
      "state": _vm.notification_state,
      "captionState": _vm.caption_state
    }
  }) : _vm._e(), _vm._v(" "), _c('login'), _vm._v(" "), (_vm.landingFirstComplete) ? _c('landing-screen') : _vm._e(), _vm._v(" "), _c('landing-first', {
    on: {
      "complete": _vm.landingFirstCompleteCb
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8be68300"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/templates/main.vue
// module id = 645
// module chunks = 1